import SchemaPage from "../../../../src/components/endpoints-page";
import * as React from 'react';
export default {
  SchemaPage,
  React
};